import { render } from "./PersonaGiuridica.vue?vue&type=template&id=68c4666f"
import script from "./PersonaGiuridica.vue?vue&type=script&lang=js"
export * from "./PersonaGiuridica.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__